
const FacebookIcon = () => {
  return (
    <img src={`${AZURE_BASE_URL}/icon_facebook.webp`} alt="Facebook" className="w-6 h-6" />
  )
}

function Facebook() {
  return (
    <div className="facebook">
      <div className="w-6 h-6 flex items-center justify-center">
        <FacebookIcon />
      </div>
      <p className="facebook__text">
        Continuar con Facebook
      </p>
    </div>
  )
}

export default Facebook